'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRouter } from 'next/navigation';
import { LuCookie } from 'react-icons/lu';

export function CookieConsentFab() {
  const router = useRouter();
  const { t } = useTranslations();

  const handleClick = () => {
    // The event opens the current contract immediately. Keep the query fallback during the fleet
    // migration because older shadow consent components still react through useSearchParams.
    const eventDetail = { handled: false };
    window.dispatchEvent(
      new CustomEvent('eliadmin:open-cookie-preferences', { detail: eventDetail }),
    );
    if (eventDetail.handled) return;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('occ', 'true');
    router.push(`${window.location.pathname}?${searchParams.toString()}${window.location.hash}`);
  };

  return (
    <Button
      onClick={handleClick}
      variant="default"
      size="icon"
      className="fixed bottom-[max(8px,env(safe-area-inset-bottom))] left-4 z-[1000] rounded-full shadow-2xl sm:bottom-8"
      aria-label={t('text267')}
    >
      <LuCookie size={24} aria-hidden="true" />
    </Button>
  );
}
